module.exports = __webpack_public_path__ + "assets/img/logo-owlpay-checkout.4874d6ec.svg";